import React, { useState, useEffect, useRef } from 'react';


const FeedbackForm = ({ 
  onCancel, 
  onSubmit, 
  categoryOptions = [], 
  severityOptions = [],
  position = {} 
}) => {
  const [category, setCategory] = useState('');
  const [severity, setSeverity] = useState('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');
  const [charCount, setCharCount] = useState(0);
  const formRef = useRef(null);

  const MAX_CHARS = 5000;

  useEffect(() => {
    // Reset form when opened
    setCategory('');
    setSeverity('');
    setComment('');
    setError('');
    setCharCount(0);
  }, [onCancel]);

  const handleCommentChange = (e) => {
    const value = e.target.value;
    if (value.length <= MAX_CHARS) {
      setComment(value);
      setCharCount(value.length);
    }
  };

  const handleSubmit = () => {
    if (!comment.trim()) {
      setError('Please provide the Description');
      return;
    }
    
    if (comment.length > MAX_CHARS) {
      setError(`Description cannot exceed ${MAX_CHARS} characters`);
      return;
    }
    
    setError('');
    onCancel();
    onSubmit({
      category: category || null,
      severity: severity || null,
      comment: comment.trim()
    });
  };

  const formStyle = position ? {
    position: 'absolute',
    right: position.right,
    top: position.top,
    zIndex: 1000,
    minHeight: '409px', // Minimum height
    height: 'auto' // Allow expansion
  } : {};

  return (
    <div className="feedback-form-container" style={formStyle} ref={formRef}>
      {/* Header section */}
      <div className="feedback-form-header">
        <h4 className="feedback-form-title">Provide Feedback</h4>
      </div>
      
      {/* Form content section */}
      <div className="feedback-form-content">
        {/* Category dropdown */}
        <div className="feedback-form-field">
          <div className="feedback-form-field-header">
            <label className="feedback-form-label">Category</label>
            <span className="feedback-form-optional">Optional</span>
          </div>
          <select 
            className="feedback-form-dropdown"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            aria-label="Category (Optional)"
          >
            <option value="">Select Category (Optional)</option>
            {categoryOptions.map(option => (
              <option key={option.id} value={option.name}>
                {option.errorCategory?.display + ': ' + option.display}
              </option>
            ))}
          </select>
        </div>

        {/* Severity dropdown */}
        <div className="feedback-form-field">
          <div className="feedback-form-field-header">
            <label className="feedback-form-label">Severity</label>
            <span className="feedback-form-optional">Optional</span>
          </div>
          <select 
            className="feedback-form-dropdown"
            value={severity}
            onChange={(e) => setSeverity(e.target.value)}
            aria-label="Severity (Optional)"
          >
            <option value="">Select Severity (Optional)</option>
            {severityOptions.map(option => (
              <option key={option.name} value={option.name}>
                {option.display}
              </option>
            ))}
          </select>
        </div>

        {/* Description textarea */}
        <div className="feedback-form-field">
          <div className="feedback-form-field-header">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label className="feedback-form-label">Description</label>
              <span className="feedback-form-required">*</span>
            </div>
            <span className="feedback-form-char-count">
              {charCount}/{MAX_CHARS}
            </span>
          </div>
          <textarea 
            className="feedback-form-textarea"
            value={comment}
            onChange={handleCommentChange}
            aria-label="Description" 
            aria-required='true' 
            placeholder='Enter your feedback description'
            rows={4}
          ></textarea>
          {error && (
            <div role="alert" className="feedback-form-error">
              {error === 'Please provide the Description' 
                ? 'Please provide the Description' 
                : 'Description exceeds the limit'}
            </div>
          )}
        </div>
      </div>
      
      {/* Footer with buttons */}
      <div className="feedback-form-footer">
        <button 
          className="feedback-form-cancel-btn"
          onClick={onCancel}
          aria-label='cancel'
        >
          Cancel
        </button>
        <button 
          className="feedback-form-submit-btn"
          onClick={handleSubmit}
          aria-label='submit'
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default FeedbackForm;